import { Controller } from "stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["searchbar", "searchPopup", "searchInput"];

  connect() {
    useClickOutside(this);
  }

  clickOutside(e) {
    this.hideSearchPopup();
  }

  showSearchPopup() {
    this.searchPopupTarget.classList.remove("tw-hidden");
    this.searchInputTarget.style.outline = 0;
    this.searchInputTarget.focus();
  }

  hideSearchPopup() {
    if (!this.searchbarTarget.className.includes("whitelisted-element")) {
      this.searchPopupTarget.classList.add("tw-hidden");
    } else {
      this.searchbarTarget.classList.remove("whitelisted-element")
    }
  }
}
